import ProductSwiper from "components/commonComponent/productSwiper";
import useTenTrendingProducts from "hook/useTenTrendingProducts";
import newIcon from "images/trendingProducts.png";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
const TrendingProducts = () => {
  const { tenTrendingProducts, loading1 } = useTenTrendingProducts();
  const { language } = useSettings();

  return (
    <div>
      <ProductSwiper
        data={tenTrendingProducts}
        loading={loading1}
        link="/trendingProducts"
        title={t("trendingProducts", language)}
        icon=""
      />
    </div>
  );
};

export default TrendingProducts;
